import { render } from "./FooterView.vue?vue&type=template&id=0746659d&scoped=true"
import script from "./FooterView.vue?vue&type=script&lang=js"
export * from "./FooterView.vue?vue&type=script&lang=js"

import "./FooterView.vue?vue&type=style&index=0&id=0746659d&scoped=true&lang=css"

import exportComponent from "D:\\work\\六合合集\\6hhjm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0746659d"]])

export default __exports__